import {onLoad} from "../../base/onLoad";
import menu from "./menu";
menu();